module.exports = __webpack_public_path__ + "static/top-sand-bkg-d37aa4014cd46b2a48ab857d2ed7e6fb.png";